import { useState } from 'react';
import PropTypes from 'prop-types';

import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import RightOutlined from '@ant-design/icons/RightOutlined';
import Avatar from 'mantis/components/@extended/Avatar';

import useInterface from 'src/hooks/useInterface';
import TextField from 'src/components/ui/TextField';
import Switcher from 'src/components/ui/Switcher';

import { ExpandMore } from './styled/ExpandMore';
import Divider from '@mui/material/Divider';

const NavUser = (props) => {
	const {
		name,
		description,
		avatar,
		drawerOpen: drawerOpenProp,
		onLogout,
		hasMenu,
		onSubmitEnter,
		onSwitchCalls,
	} = props;

	const theme = useTheme();

	const { isDrawerOpen } = useInterface();
	const drawerOpen =
		drawerOpenProp === undefined ? isDrawerOpen : drawerOpenProp;

	const [anchorEl, setAnchorEl] = useState(null);
	const open = Boolean(anchorEl);

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};

	const expandNode = (
		<ExpandMore
			theme={theme}
			expand={open}
			drawerOpen={drawerOpen}
			id="basic-button"
			aria-controls={open ? 'basic-menu' : undefined}
			aria-haspopup="true"
			aria-expanded={open ? 'true' : undefined}
			onClick={handleClick}
			aria-label="show more"
		>
			<RightOutlined style={{ fontSize: '0.625rem' }} />
		</ExpandMore>
	);

	return (
		<Box
			sx={{
				py: 1,
				borderTop: '2px solid',
				borderTopColor: 'divider',
			}}
		>
			<List disablePadding>
				<ListItem
					secondaryAction={hasMenu ? expandNode : undefined}
					sx={{
						py: !drawerOpen ? 0 : 1,
						px: !drawerOpen ? 1.25 : 3,
						'& .MuiListItemSecondaryAction-root': {
							right: !drawerOpen ? -20 : -16,
						},
					}}
				>
					<ListItemAvatar>
						<Avatar
							alt="Avatar"
							src={avatar}
							sx={{
								...(drawerOpen && { width: 46, height: 46 }),
							}}
						/>
					</ListItemAvatar>
					<ListItemText primary={name} secondary={description} />
				</ListItem>
				{drawerOpen && (
					<>
						{onSwitchCalls && (
							<ListItem sx={{ pt: 1, pb: 2, pl: 4, pr: 2 }}>
								<Switcher
									label={
										<Typography variant="body1">
											Принимать звонки
										</Typography>
									}
									onChange={onSwitchCalls}
								/>
							</ListItem>
						)}
						{onSubmitEnter && (
							<>
								<Divider />
								<ListItem sx={{ py: 2, px: 3 }}>
									<form onSubmit={onSubmitEnter}>
										<TextField
											nam="gorkoId"
											label="Войти как"
											placeholder="Gorko ID"
										/>
									</form>
								</ListItem>
							</>
						)}
					</>
				)}
			</List>
			{hasMenu && (
				<Menu
					id="basic-menu"
					anchorEl={anchorEl}
					open={open}
					onClose={handleClose}
					MenuListProps={{ 'aria-labelledby': 'basic-button' }}
					anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
					transformOrigin={{
						vertical: 'bottom',
						horizontal: 'right',
					}}
				>
					{onLogout && <MenuItem onClick={onLogout}>Logout</MenuItem>}
				</Menu>
			)}
		</Box>
	);
};

NavUser.propTypes = {
	name: PropTypes.string,
	description: PropTypes.string,
	avatar: PropTypes.string,
	drawerOpen: PropTypes.bool,
	onLogout: PropTypes.func,
	hasMenu: PropTypes.bool,
	onSubmitEnter: PropTypes.func,
	onSwitchCalls: PropTypes.func,
};

export default NavUser;
